module.exports = __webpack_public_path__ + "static/media/Hours55.aa43b7f7.png";